import React from "react";
import DeviceAttendance from "./DeviceAttendance";

function DeptTransactionDetailsReportPage() {
    return (
        <DeviceAttendance
            reportType="Department"
            title="Dept Attendance"
            exportFileName="DeptAttendance"
        />
    );
}

export default DeptTransactionDetailsReportPage;
